'use client';
import React from 'react';
import { Div, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import BackgroundImage from '../sub-component/background-image';
import SpecialityItem from './speciality-item';
import { Slider } from '@pezeshk-book/modules';

const imageSize = {
  Tablet: {
    height: '282px',
    width: '215px',
  },
  TabletHor: {
    height: '451px',
    width: '258px',
  },
  HD: {
    width: '230px',
    height: '534px',
  },
  MidHD: {
    width: '280px',
    height: '657px',
  },
  FullHD: {
    width: '280px',
    height: '550px',
  },
};

const SpecialtiesSection = ({ specialtyData, translate }: any) => {
  return (
    <Div className={'justify-around w-full flex-col items-center self-center gap-y-4'}>
      <Div className={'flex-col items-center gap-y-4'}>
        <Text color={'grey.900'} typography={'xl'} type={'bold'} align={'center'}>{translate.title}</Text>
        <Text color={'grey.500'} align={'start'} typography={'xl'} type={'bold'}>{translate.sub_title}</Text>
      </Div>
      <Div className={'w-full'}>
        <BackgroundImage imageSize={imageSize}>
          <Image
            className={'object-contain'}
            alt={'image'}
            src={'/images/home-screen/background-svg/nurse.png'}
            sizes={'(max-width: 639px) 50vw, (max-width: 1023px) 33vw, 25vw'}
          />
        </BackgroundImage>
        <Div className={'w-full flex-col self-center max-width-[350px] min-w-[340px]'}>
          <Slider slides={6} tabletSlides={4} mobileSlides={3} rows={2} spaceBetween={20} infiniteLoop={true}>
            {specialtyData && specialtyData.length > 0 && specialtyData.map((special: any) => (
              <SpecialityItem
                key={`SpecialityItem${special?.id}`}
                src={special?.image?.key_0?.url}
                title={special?.title}
                id={special?.id.toString()}
              />
            ))}
          </Slider>
        </Div>
      </Div>
    </Div>
  );
};
export default SpecialtiesSection;
